import { Button as AntButton, ConfigProvider } from 'antd';
import { useState } from 'react';

const buttonStyles = {
  default: {
    backgroundColor: 'transparent',
    color: '#fff',
    hoverBg: 'rgba(255, 255, 255, 0.1)',
    border: 'rgba(255, 255, 255, 0.1)',
    hoverColor: '#fff',
    defaultHoverBg: 'rgba(255, 255, 255, 0.1)',
    defaultHoverColor: '#fff',
  },
  primary: {
    // backgroundColor: 'var(--success-color)',
    color: '#fff',
    //   border: 'none',
  },
  danger: {
    backgroundColor: 'var(--error-color)',
    color: '#fff',
    border: 'none',
    hoverBg: 'var(--error-hover-color)',
  },
  success: {
    backgroundColor: 'var(--success-color)',
    color: '#000',
    border: 'none',
    hoverBg: 'var(--success-hover-color)',
  },
  icon: {
    backgroundColor: 'transparent',
    color: '#fff',
    border: 'none',
    hoverBg: 'rgba(255, 255, 255, 0.1)',
    hoverColor: '#fff',
  }
};

const Button = ({
  type = 'default',
  style = {},
  loading = false,
  children,
  ...props
}) => {

  const [isLoading, setIsLoading] = useState(loading);
  const { onClick, loading: _, ...restProps } = props;
const handleClick = async (e) => {
  if (onClick) {
    setIsLoading(true);
    try {
      const result = onClick(e);
      // Check if the result is a Promise
      if (result && typeof result.then === 'function') {
        await result;
      }
    } catch (error) {
      console.error('Button action failed:', error);
    } finally {
      setIsLoading(false);
    }
  }
};

  // Map custom types to valid Ant Design types
  const getAntType = (customType) => {
    if (['success', 'danger', 'icon', 'success_alt'].includes(customType)) {
      return 'default';
    }
    return customType;
  };

  // Get theme configuration based on type
  const getThemeConfig = () => {
    const currentStyle = buttonStyles[type] || buttonStyles.default;

    if (type === 'success' || type === 'danger' || type === 'icon' || type === 'default' || type === 'success_alt') {
      return {
        defaultBg: currentStyle.backgroundColor,
        defaultHoverBg: currentStyle.hoverBg || currentStyle.backgroundColor,
        defaultColor: currentStyle.color,
        defaultBorderColor: currentStyle.border || 'transparent',
        defaultHoverBorderColor: currentStyle.border || 'transparent',
        defaultHoverColor: currentStyle.hoverColor || currentStyle.color,
        fontSize: 14,
        defaultShadow: 'none',
      };
    }
    
    // For standard Ant Design types (primary, default)
    return {
      fontSize: 14,
      defaultShadow: 'none',
    };
  };

  return (
    <ConfigProvider theme={{
      components: {
        Button: getThemeConfig(),
      },
    }}>
      <AntButton iconPosition='start'
        style={{ ...style }}
        styles={{
          icon: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }
        }}
        type={getAntType(type)}
        loading={isLoading}
        onClick={handleClick}
        {...restProps}
      >
        {children}
      </AntButton>
    </ConfigProvider>
  );
}

export default Button;